export const TimeoutDurationsEnum = {
  PRICE_MATRIX_DELAY: 100
};
